import Aura from '@primeuix/themes/aura';
import { definePreset } from '@primeuix/themes';

export const SuburbanSupplyPreset = definePreset(Aura, {
  primitive: {
    suburbanSupply: {
      200: '#CBE7C8',
      300: '#007F041A',
      400: '#007F0480',
      500: '#007F04',
      600: '#009102',
      700: '#006902',
    },
  },
  semantic: {
    primary: {
      200: '{suburbanSupply.200}',
      300: '{suburbanSupply.300}',
      400: '{suburbanSupply.400}',
      500: '{suburbanSupply.500}',
      600: '{suburbanSupply.600}',
      700: '{suburbanSupply.700}',
    },
  },
});
